<template>
  <div v-if="!loader">
    <b-card class="row-height" no-body>
      <div>
        <b-card no-body class="card-statistics" style="">
          <b-card-body class="statistics-body">
            <b-row class="align-items-center ">
              <b-col gap="3" class="align-items-center flex-row d-flex justify-content-between">
                <h2 class="text-purple font-weight-bold">
                  <b-link class="btn btn-outline-primary btn-sm" to="/">
                    <FeatherIcon icon="ChevronLeftIcon"></FeatherIcon>
                    {{ $t("back") }}
                  </b-link>
                  {{ $t("annual_activity_summary") }}
                </h2>
              </b-col>
            </b-row>

            <br>
            <br>

            <template>
              <BRow align-content="center" class="justify-content-between">
                <BCol sm="4">
                  <BRow align-content="center" class="justify-content-between align-items-center pl-1">
                    <template>
                      {{ $t('transaction_report') }}
                    </template>
                    <BCol sm="4">
                      <BForm-Select
                          id="yearSelect"
                          v-model="transactionYear"
                          name="year"
                          :options="yearOptions"
                      />
                    </BCol>
                    <BButton @click="downloadTransactionPdfReport" variant="primary" size="sm" class="mr-1">
                      <FeatherIcon size="12" icon="DownloadIcon"/>
                      PDF
                    </BButton>
                    <BButton @click="downloadTransactionCsvReport" variant="primary" size="sm">
                      <FeatherIcon size="12" icon="DownloadIcon"/>
                      CSV
                    </BButton>
                  </BRow>
                </BCol>
                <b-form>
                  <b-col v-if="yearOptions.length !== 0" class="d-flex m-0 align-items-center justify-content-end" style="gap:20px">
                    <b-form-group
                        label-for="yearSelect"
                        label-align-sm="right"
                        class="mb-0 d-flex align-items-center"
                        style="gap: 15px"
                    >
                      <template #label>
                        <h5 class="m-0">{{ $t('statement_year') }} :</h5>
                      </template>

                      <b-form-select
                          id="yearSelect"
                          v-model="selectedYear"
                          name="year"
                          :options="yearOptions"
                          @change="getAnnualActivitySummary()"
                      ></b-form-select>
                    </b-form-group>
                    <b-form-group label="" class="m-0 d-flex">
                      <b-button @click="downloadAnnualActivityPdf()" variant="primary" size="md" class="d-flex">
                        <FeatherIcon size="12" icon="DownloadIcon" class="mr-1"></FeatherIcon>
                        {{ $t('download_pdf') }}
                      </b-button>
                    </b-form-group>
                  </b-col>
                </b-form>
              </BRow>

              <div v-if="loaderForTable" class="d-flex justify-content-center align-items-center">
                <img src="/new-loader.svg"  alt="Loader"/>
              </div>
              <div v-else>
                <div v-if="yearOptions.length === 0" class="mt-5 text-center">
                  <feather-icon icon="InfoIcon" size="50" class="text-muted mb-2"/>
                  <h4 class="text-muted">{{ $t('no_annual_activity_summaries_available') }}</h4>
                  <p class="text-muted small">
                    {{ $t('summaries_are_generated_for_completed_calendar_years') }}
                  </p>
                </div>
                <div v-else-if="annualActivityData" class="mt-3">
                  
                  <!-- Section 1: Annual Summary -->
                  <h3 class="mt-2 mb-0 text-purple font-weight-bold">{{ $t('annual_summary') }} (01.01.{{ selectedYear }} – 31.12.{{ selectedYear }})</h3>
                  <table class="styled-table">
                    <thead>
                    <tr>
                      <th>{{ $t('currency') }}</th>
                      <th>{{ $t('total_invoices_sold') }}</th>
                      <th>{{ $t('total_original_amount_sold') }}</th>
                      <th>{{ $t('total_platform_discount_charged') }}</th>
                      <th>{{ $t('total_liquidity_received') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(row, currency) in annualActivityData.summary_per_currency" :key="'summary-' + currency">
                      <th scope="row">{{ currency }}</th>
                      <td>{{ row.total_invoices_sold }}</td>
                      <td>{{ amountFormat(row.total_original_amount_sold, currency) }}</td>
                      <td>{{ amountFormat(row.total_platform_discount_charged, currency) }}</td>
                      <td>{{ amountFormat(row.total_liquidity_received, currency) }}</td>
                    </tr>
                    </tbody>
                  </table>

                  <!-- Section 2: Settlements Overview (if any) -->
                  <div v-if="annualActivityData.settlements && annualActivityData.settlements.length > 0">
                      <h3 class="mt-3 mb-0 text-purple font-weight-bold">{{ $t('settlements_overview') }} </h3>
                      <b-table
                          :items="annualActivityData.settlements"
                          :fields="settlementFields"
                          small
                          bordered
                          responsive
                          class="styled-table mt-1"
                      >
                        <template #cell(id)="data">
                          {{ data.item.id ? 'I-' + data.item.id : '-' }}
                        </template>
                        <template #cell(sold_date)="data">
                          {{ data.item.sold_date ? data.item.sold_date : '-' }}
                        </template>
                        <template #cell(amount)="data">
                          {{ amountFormat(data.item.amount, data.item.currency) }}
                        </template>
                      </b-table>
                  </div>

                  <!-- Section 3: Account balance -->
                  <h3 class="mt-3 mb-0 text-purple font-weight-bold">{{ $t('saldo_balance') }}</h3>
                  <p>({{ $t('as_of') }} 31.12.{{ selectedYear }})</p>
                  <table class="styled-table">
                    <thead>
                    <tr>
                      <th>{{ $t('currency') }}</th>
                      <th v-for="(balance, currency) in annualActivityData.balances" :key="'balance-header-' + currency">
                        {{ currency.toUpperCase() }}
                      </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                      <th scope="row">{{ $t('saldo_balance') }}</th>
                      <td v-for="(balance, currency) in annualActivityData.balances" :key="'balance-value-' + currency">
                        {{ amountFormat(balance, currency) }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </template>

          </b-card-body>
        </b-card>
      </div>
    </b-card>
  </div>
  <div v-else>
    <img src="/new-loader.svg" alt="Loading"/>
  </div>
</template>
<script>
import fileDownload from "js-file-download";
import {CurrencyAmountFormat} from '@core/utils/CurrencyAmountFormat';

export default {
  data() {
    return {
      selectedYear: null,
      annualActivityData: null,
      company: null,
      loader: false,
      loaderForTable: false,
      transactionYear: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    amountFormat(amount, currency) {
      return CurrencyAmountFormat(amount, currency)
    },
    getData() {
      this.loader = true;
      this.$store
          .dispatch('app/fetchCompany')
          .then((data) => {
            if (data?.value) {
              this.company = data.value;
              this.loader = false;
              this.initSelectedYear();
            }
          });
    },
    initSelectedYear() {
      if (this.yearOptions.length > 0) {
        this.selectedYear = this.yearOptions[this.yearOptions.length - 1].value;
        this.transactionYear = this.yearOptions[this.yearOptions.length - 1].value;
        this.getAnnualActivitySummary();
      }
    },
    getAnnualActivitySummary() {
      if (!this.selectedYear) return;
      this.loaderForTable = true;
      this.$http.get(`/company/invoiceForSeller/annual-activity-summary`, {params: {year: this.selectedYear}})
          .then(res => {
            this.annualActivityData = res.data.value || res.data;
          })
          .finally(() => {
            this.loaderForTable = false;
          });
    },
    downloadAnnualActivityPdf() {
      const year = this.selectedYear;
      this.$http.post(`/company/invoiceForSeller/annual-activity-summary/pdf`, {year: this.selectedYear}, {responseType: 'blob'})
          .then(response => {
            fileDownload(response.data, `annual-activity-summary-${year}.pdf`);
          });
    },
    downloadTransactionPdfReport() {
      const url = '/transactions/export/pdf';
      const payload = {company_id: this.$store.state.auth.user.company_id, year: this.transactionYear}
      this.$http.post(url, payload, {responseType: 'blob'}).then((response) => {
        fileDownload(response.data, this.$t('transaction_report_pdf'));
      });
    },
    downloadTransactionCsvReport() {
      const url = '/transactions/export/csv';
      const payload = {company_id: this.$store.state.auth.user.company_id, year: this.transactionYear}
      this.$http.post(url, payload, {responseType: 'blob'}).then((response) => {
        const filename = this.$t('transaction_report_csv');
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveBlob(response.data, filename);
        } else {
          const link = document.createElement('a');
          link.href = URL.createObjectURL(response.data);
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    }
  },
  computed: {
    yearOptions() {
      if (!this.company?.created_at) return []
      const startYear = new Date(this.company.created_at).getFullYear()
      const lastYear = new Date().getFullYear() - 1 
      const years = []
      if (startYear > lastYear) return [];
      for (let year = startYear; year <= lastYear; year++) {
        years.push({
          value: year,
          text: year.toString(),
        })
      }
      return years
    },
    settlementFields(){
      return [
        {key: 'id', label: this.$t('invoice_id') },
        {key: 'issue_date', label: this.$t('issue_date')},
        {key: 'sold_date', label: this.$t('financing_date')},
        {key: 'settlement_date', label: this.$t('settlement_date')},
        {key: 'amount', label: this.$t('amount')},
        {key: 'currency', label: this.$t('currency')},
      ]
    },
  },
};
</script>
<style scoped>
.styled-table {
  margin-top: 50px;
  border-collapse: collapse;
  font-size: 14px;
  width: 100%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

.styled-table thead tr {
  background-color: #798581;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
}

.styled-table th,
.styled-table td {
  padding: 12px 15px;
  border: 1px solid #dee2e6;
  text-align: center;
}

.styled-table tbody tr:nth-child(even) {
  background-color: #f3f3f3;
}

.styled-table tbody tr:hover {
  background-color: #e9ecef;
}

.styled-table {
  margin-top: 0;
}
</style>
